import { render, staticRenderFns } from "./UniversidadesPage.vue?vue&type=template&id=105916f6"
import script from "./UniversidadesPage.js?vue&type=script&lang=js&external"
export * from "./UniversidadesPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports